import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'

import { TranslatePipe } from '@ngx-translate/core'
import { PrimeTemplate } from 'primeng/api'
import { Button } from 'primeng/button'
import { Dialog } from 'primeng/dialog'
import { Fluid } from 'primeng/fluid'
import { InputText } from 'primeng/inputtext'

import { ForgotPasswordViewModel } from '../../models/forgot-password.model'

@Component({
  selector: 'app-forgot-password',
  templateUrl: 'forgot-password.component.html',
  styleUrl: 'forgot-password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Button, Dialog, Fluid, PrimeTemplate, InputText, ReactiveFormsModule, TranslatePipe],
})
export class ForgotPasswordComponent {
  protected readonly viewModel = inject(ForgotPasswordViewModel)

  public open() {
    this.viewModel.form.reset()
    this.viewModel.isFormOpened.set(true)
    this.viewModel.apiErrorMessage.set('')
  }
}
